import { Trophy } from "lucide-react";
import { TestResult } from "@/hooks/useTestResults";

interface RecentAchievementProps {
  testResults?: TestResult[];
  isLoading: boolean;
}

export const RecentAchievement = ({ testResults, isLoading }: RecentAchievementProps) => {
  if (isLoading) {
    return (
      <div className="space-y-2">
        <h4 className="text-sm font-medium text-gray-700">Highest Recent Score</h4>
        <p className="text-sm text-muted-foreground">Loading...</p>
      </div>
    );
  }

  if (!testResults?.length) {
    return (
      <div className="space-y-2">
        <h4 className="text-sm font-medium text-gray-700">Highest Recent Score</h4>
        <p className="text-sm text-muted-foreground">No test results yet</p>
      </div>
    );
  }

  // Get the highest score from recent tests
  const highestScore = Math.max(...testResults.map(result => result.score));
  const highestScoreTest = testResults.find(result => result.score === highestScore);

  if (!highestScoreTest) return null;

  return (
    <div className="space-y-2">
      <h4 className="text-sm font-medium text-gray-700">Highest Recent Score</h4>
      <div className="flex items-center space-x-2 p-2 rounded-lg bg-primary/5">
        <Trophy className="h-4 w-4 text-primary" />
        <div>
          <p className="font-medium text-sm">{highestScore}% in {highestScoreTest.tests.category}</p>
          <p className="text-xs text-muted-foreground">
            {new Date(highestScoreTest.created_at).toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
};